import { render, staticRenderFns } from "./Solicitante.vue?vue&type=template&id=dd05c138&scoped=true&"
import script from "./Solicitante.vue?vue&type=script&lang=js&"
export * from "./Solicitante.vue?vue&type=script&lang=js&"
import style0 from "./Solicitante.vue?vue&type=style&index=0&id=dd05c138&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd05c138",
  null
  
)

export default component.exports